// extracted by mini-css-extract-plugin
export default {"signupIcons":"Signup_signupIcons__S5q3d"};